module.exports = __webpack_public_path__ + "img/w-robot.b68c25a9.png";